module.exports = __webpack_public_path__ + "1_0_64/img/default.090d36b3.png";